import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import FormattedPrice from 'components/FormattedPrice';
import ToggleCheckbox from 'components/ToggleCheckbox';
import { selectChargeById } from 'selectors/charges';
import { selectOrder } from 'selectors/order';
import { setOptedOutChargeIds } from 'actions/order';
import { StyledPriceItem, StyledPrice } from './styles';

const LineContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
`;
const ToggleWrapper = styled.div`
  margin-left: auto;
  label {
    margin: 0 !important;
    height: 25px;
  }
`;

const ChargeLineItem = ({ item, taxIncludedMsg }) => {
  const dispatch = useDispatch();
  const { name, unit_price: unitPrice } = item.toJS();

  const chargeId = item.getIn(['details', 'charge_id']);
  const chargeData = useSelector(state => (chargeId ? selectChargeById(state, chargeId) : undefined));

  const order = useSelector(state => selectOrder(state));
  const optedOutChargeIds = order?.get('optedOutChargeIds')?.toJS() || [];

  const isOptedOut = optedOutChargeIds.includes(chargeId);
  const isInactiveDueToPrice = unitPrice === 0;
  const isInactive = isOptedOut || isInactiveDueToPrice;

  const [isActive, setIsActive] = useState(!isInactive);

  useEffect(() => {
    setIsActive(!isInactive);
  }, [isInactive]);

  const handleToggle = checked => {
    setIsActive(checked);

    let newOptedOutChargeIds;
    if (checked) {
      newOptedOutChargeIds = optedOutChargeIds.filter(id => id !== chargeId);
    } else {
      newOptedOutChargeIds = [...optedOutChargeIds, chargeId];
    }

    dispatch(setOptedOutChargeIds(newOptedOutChargeIds));
  };

  return (
    <StyledPriceItem>
      <LineContainer>
        <span>
          {name}
          {taxIncludedMsg && <small>{taxIncludedMsg}</small>}
        </span>
        {chargeData?.get('allow_opt_out') && (
          <ToggleWrapper>
            <ToggleCheckbox
              checked={isActive}
              onChange={handleToggle}
              height={24}
              width={42}
              iconHeight={18}
              iconWidth={18}
            />
          </ToggleWrapper>
        )}
      </LineContainer>
      <StyledPrice>
        <FormattedPrice value={unitPrice} />
      </StyledPrice>
    </StyledPriceItem>
  );
};

ChargeLineItem.propTypes = {
  item: PropTypes.shape({
    text: PropTypes.node,
    price: PropTypes.number,
  }).isRequired,
  taxIncludedMsg: PropTypes.node,
};

export default ChargeLineItem;
